'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "\u0434\u043f",
      "\u043f\u043f"
    ],
    "DAY": [
      "\u043d\u0435\u0434\u0456\u043b\u044f",
      "\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a",
      "\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a",
      "\u0441\u0435\u0440\u0435\u0434\u0430",
      "\u0447\u0435\u0442\u0432\u0435\u0440",
      "\u043f\u02bc\u044f\u0442\u043d\u0438\u0446\u044f",
      "\u0441\u0443\u0431\u043e\u0442\u0430"
    ],
    "ERANAMES": [
      "\u0434\u043e \u043d\u0430\u0448\u043e\u0457 \u0435\u0440\u0438",
      "\u043d\u0430\u0448\u043e\u0457 \u0435\u0440\u0438"
    ],
    "ERAS": [
      "\u0434\u043e \u043d.\u0435.",
      "\u043d.\u0435."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "\u0441\u0456\u0447\u043d\u044f",
      "\u043b\u044e\u0442\u043e\u0433\u043e",
      "\u0431\u0435\u0440\u0435\u0437\u043d\u044f",
      "\u043a\u0432\u0456\u0442\u043d\u044f",
      "\u0442\u0440\u0430\u0432\u043d\u044f",
      "\u0447\u0435\u0440\u0432\u043d\u044f",
      "\u043b\u0438\u043f\u043d\u044f",
      "\u0441\u0435\u0440\u043f\u043d\u044f",
      "\u0432\u0435\u0440\u0435\u0441\u043d\u044f",
      "\u0436\u043e\u0432\u0442\u043d\u044f",
      "\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430",
      "\u0433\u0440\u0443\u0434\u043d\u044f"
    ],
    "SHORTDAY": [
      "\u041d\u0434",
      "\u041f\u043d",
      "\u0412\u0442",
      "\u0421\u0440",
      "\u0427\u0442",
      "\u041f\u0442",
      "\u0421\u0431"
    ],
    "SHORTMONTH": [
      "\u0441\u0456\u0447.",
      "\u043b\u044e\u0442.",
      "\u0431\u0435\u0440.",
      "\u043a\u0432\u0456\u0442.",
      "\u0442\u0440\u0430\u0432.",
      "\u0447\u0435\u0440\u0432.",
      "\u043b\u0438\u043f.",
      "\u0441\u0435\u0440\u043f.",
      "\u0432\u0435\u0440.",
      "\u0436\u043e\u0432\u0442.",
      "\u043b\u0438\u0441\u0442.",
      "\u0433\u0440\u0443\u0434."
    ],
    "STANDALONEMONTH": [
      "\u0421\u0456\u0447\u0435\u043d\u044c",
      "\u041b\u044e\u0442\u0438\u0439",
      "\u0411\u0435\u0440\u0435\u0437\u0435\u043d\u044c",
      "\u041a\u0432\u0456\u0442\u0435\u043d\u044c",
      "\u0422\u0440\u0430\u0432\u0435\u043d\u044c",
      "\u0427\u0435\u0440\u0432\u0435\u043d\u044c",
      "\u041b\u0438\u043f\u0435\u043d\u044c",
      "\u0421\u0435\u0440\u043f\u0435\u043d\u044c",
      "\u0412\u0435\u0440\u0435\u0441\u0435\u043d\u044c",
      "\u0416\u043e\u0432\u0442\u0435\u043d\u044c",
      "\u041b\u0438\u0441\u0442\u043e\u043f\u0430\u0434",
      "\u0413\u0440\u0443\u0434\u0435\u043d\u044c"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d MMMM y '\u0440'.",
    "longDate": "d MMMM y '\u0440'.",
    "medium": "d MMM y '\u0440'. HH:mm:ss",
    "mediumDate": "d MMM y '\u0440'.",
    "mediumTime": "HH:mm:ss",
    "short": "dd.MM.yy HH:mm",
    "shortDate": "dd.MM.yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20b4",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": "\u00a0",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "uk-ua",
  "localeID": "uk_UA",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  if (vf.v == 0 && i % 10 == 0 || vf.v == 0 && i % 10 >= 5 && i % 10 <= 9 || vf.v == 0 && i % 100 >= 11 && i % 100 <= 14) {    return PLURAL_CATEGORY.MANY;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

(function() {
    'use strict';

    angular.module('mainApp', [
        'ngAnimate',
        'ngRoute',
        'ngSanitize',
        'ui.bootstrap',
        'ngMeta',
        'core',
        'homePage',
        'categoryList',
        'categoryPage',
        'categoryDetail',
        'productDetail',
        'productList',
        'angular-carousel',
        'ngMap'
    ])
        .run(['Cart','$rootScope','ngMeta', 'myGoogleAnalytics', function(Cart, $rootScope, ngMeta, myGoogleAnalytics) {
            Cart.getContent();
            //Add a suffix to all page titles
            ngMeta.init();
            var myGoogleAnalytics = {};

            /**
             * Set the page to the current location path
             * and then send a pageview to log path change.
             */
            myGoogleAnalytics.sendPageview = function() {
                if ($window.ga) {
                    $window.ga('set', 'page', $location.path());
                    $window.ga('send', 'pageview');
                }
            };
        }])

        .filter("sanitize", ['$sce', function($sce) {
            return function(htmlCode){
                return $sce.trustAsHtml(htmlCode);
            };
        }])
        .directive('phoneInput', ['$filter', '$browser', function($filter, $browser) {
            return {
                require: 'ngModel',
                link: function($scope, $element, $attrs, ngModelCtrl) {
                    var listener = function() {
                        var value = $element.val().replace(/[^0-9]/g, '');
                        $element.val($filter('tel')(value, false));
                    };
                    ngModelCtrl.$parsers.push(function(viewValue) {
                        return viewValue.replace(/[^0-9]/g, '').slice(0,10);
                    });

                    ngModelCtrl.$render = function() {
                        $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
                    };
                    $element.bind('change', listener);
                    $element.bind('keydown', function(event) {
                        var key = event.keyCode;

                        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
                            return;
                        }
                        $browser.defer(listener);
                    });

                    $element.bind('paste cut', function() {
                        $browser.defer(listener);
                    });
                }

            };
        }])
        .filter('tel', function () {
            return function (tel) {
                if (!tel) { return ''; }

                var value = tel.toString().trim().replace(/^\+/, '');

                if (value.match(/[^0-9]/)) {
                    return tel;
                }

                var country, city, number;

                switch (value.length) {
                    case 1:
                    case 2:
                    case 3:
                        city = value;
                        break;

                    default:
                        city = value.slice(0, 3);
                        number = value.slice(3);
                }

                if(number){
                    if(number.length>3){
                        number = number.slice(0, 3) + '-' + number.slice(3,7);
                    }
                    else{
                        number = number;
                    }

                    return ("(" + city + ") " + number).trim();
                }
                else{
                    return "(" + city;
                }

            };
        })
        .factory('httpErrorResponseInterceptor', ['$q', '$location',
            function($q, $location) {
                return {
                    response: function(responseData) {
                        return responseData;
                    },
                    responseError: function error(response) {
                        switch (response.status) {
                            case 404:
                                $location.path('/404');
                                break;
                            default:
                                $location.path('/404');
                        }

                        return $q.reject(response);
                    }
                };
            }
        ])
    .factory('myGoogleAnalytics', [
        '$rootScope', '$window', '$location',
        function ($rootScope, $window, $location) {

            var myGoogleAnalytics = {};

            /**
             * Set the page to the current location path
             * and then send a pageview to log path change.
             */
            myGoogleAnalytics.sendPageview = function() {
                if ($window.ga) {
                    $window.ga('set', 'page', $location.path());
                    $window.ga('send', 'pageview');
                }
            };

            // subscribe to events
            $rootScope.$on('$viewContentLoaded', myGoogleAnalytics.sendPageview);

            return myGoogleAnalytics;
        }
    ])
        .controller('PageController', ['$anchorScroll', '$location', '$scope', '$timeout',
            function($anchorScroll, $location, $scope, $timeout) {
                var today = new Date();
                this.year = today.getFullYear();
                this.gotoHeader = function() {
                    window.scrollTo(0, 0);
                };
            }
        ]);
})();
angular.
module('mainApp').
config(['$locationProvider' ,'$routeProvider','ngMetaProvider', '$httpProvider', '$compileProvider',
    function config($locationProvider, $routeProvider, ngMetaProvider, $httpProvider, $compileProvider) {
        'use strict';

        $locationProvider.html5Mode(true).hashPrefix('!');

        $compileProvider.debugInfoEnabled(false);

        ngMetaProvider.useTitleSuffix(true);
        ngMetaProvider.setDefaultTitleSuffix(' | Food Service');
        $httpProvider.interceptors.push('httpErrorResponseInterceptor');

        $routeProvider.
        when('/', {
            template: '<home-page slides="$resolve.slides"></home-page>',
            resolve: {
                slides: ['slidesService', function(slidesService) {
                    return slidesService.getSlides();
                }]
            },
            title: 'Главная',
            meta: {
                'title': 'Главная',
                'description': 'This is the description shown in Google search results',
                'image': '/images/logos/logo.png'
            }
        }).
        when('/categories', {
            template: '<category-page categories="$resolve.categories"></category-page>',
            resolve: {
                categories: ['$route', 'Category', function ($route, Category) {
                    return Category.query().$promise;
                }]
            },
            meta: {
                'title': 'Каталог',
                'description': 'This is the description shown in Google search results',
                'image': '/images/logos/logopng.png'
            }
        }).
        when('/categories/page/:page', {
            template: '<category-page categories="$resolve.categories"></category-page>',
            resolve: {
                categories: ['$route', 'Category', function ($route, Category) {
                    return Category.get({page: $route.current.params.page}).$promise;
                }]
            },
            meta: {
                'title': 'Каталог',
                'description': 'This is the description shown in Google search results',
                'image': '/images/logos/logopng.png'
            }
        }).
            when('/categories/:slug', {
                template: '<category-detail category="$resolve.category"></category-detail>',
                resolve: {
                    category: ['$route', 'Category', function ($route, Category) {
                        return Category.get({slug: $route.current.params.slug}).$promise;
                    }]
                },
            }).
        when('/product/:slug', {
            template: '<product-detail item="$resolve.product"></product-detail>',
            resolve: {
                product: ['$route', 'Product', function ($route, Product) {
                    return Product.get({slug: $route.current.params.slug}).$promise;
                }]
            }
        }).
        when('/cart/checkout', {
            template: '<cart-checkout></cart-checkout>',
            meta: {
                'title': 'Корзина',
                'description': 'This is the description shown in Google search results',
                'image': '/images/logos/logopng.png'
            }
        }).
        when('/contacts', {
            templateUrl: '/views/app/contacts/contacts.template.html',
            meta: {
                'title': 'Контакты',
                'description': 'This is the description shown in Google search results',
                'og:title': 'Контакты Foods-Service',
                'og:description': 'This is the description shown in Google search results',
                'image': '/images/logos/logopng.png'
            }
        }).
        when('/payment', {
            templateUrl: '/views/app/pages/payment.html',
            meta: {
                'title': 'Доставка и оплата',
                'description': 'This is the description shown in Google search results',
                'image': '/images/logos/logopng.png',
                'og:description': 'This is the description shown in Google search results',
            }
        }).
        when('/404', {
            templateUrl: '/views/app/not-found/404.template.html',
            meta: {
                'title': 'Не найдено',
                'description': 'This is the description shown in Google search results',
            }
        }).
        otherwise('/404');
    }
]);
'use strict';

angular.module('core', [
    'core.category',
    'core.product',
    'core.cart',
    'core.nav',
    'core.pagination',
    'core.slides',
]);
'use strict';
angular.module('core.category', ['ngResource', 'ngSanitize']);
'use strict';

angular.module('core.category').factory('Category', ['$resource',
    function ($resource) {
        return $resource('/api/categories/:slug',
            {slug: '@slug'},
            {
                query: {
                    method: 'GET', isArray:true
                },
                get: {
                    method: 'GET'
                },
            });
    }
]);
'use strict';
angular.module('core.product', ['ngResource', 'ngSanitize']);
'use strict';

angular.module('core.product').factory('Product', ['$resource',
    function ($resource) {
        return $resource('/api/products/:slug',
            {slug: '@slug'},
            {
                query: {
                    method: 'GET',
                },
                get: {
                    method: 'GET'
                },
            });
    }
]);
'use strict';
angular.module('core.cart', []);
'use strict';

angular.
module('core.cart').
factory('Cart', ['$rootScope', '$http', '$q',
    function($rootScope, $http, $q) {
        var Cart = {
            total: 0,
            products: [],
            totalPrice: 0,
            length:0
        };

        Cart.add = function(data){
            return $http.post('/api/cart/add/'+data.id, data)
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        return res;
                    } else {
                        // invalid response
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };
        Cart.update = function(product){
            return $http.put('/api/cart/update/'+product.rowId, product)
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        return res;
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };
        Cart.remove = function(rowId){
            return $http.delete('/api/cart/remove/'+rowId)
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        console.log(res);
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };

        Cart.getContent = function(){
            return $http.get('/api/cart/content/')
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        Cart.products = res;
                        Cart.length = Object.keys(res).length;
                        Cart.getTotal();
                        return res;
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };

        Cart.getTotal = function(){
            return $http.get('/api/cart/total/')
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        Cart.total = res;
                        return res;
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };

        Cart.sendOrder = function (data) {
            return $http({
                method  : 'POST',
                url     : '/api/order',
                data    : data,
                headers : {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        Cart.getTotal();
                        return res;
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
        };
        return Cart;
    }
]);
'use strict';

angular.
module('core.cart').
    directive('addtoCart', ['Cart','$timeout', function(Cart, $timeout){
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                id:'@',
                quantity:'@',
                loading:'@'
            },
            link: function(scope, element, attrs) {
                var cartProducts = Cart.products;
                if(scope.quantity > 1){
                    scope.minQuantity = parseInt(scope.quantity);
                    scope.q = parseInt(scope.quantity);
                } else{
                    scope.minQuantity = 1;
                    scope.q = 1;
                }

                scope.loading = false;
                scope.showTotal = false;

                scope.addToCart = function () {
                    scope.loading = true;
                    scope.showTotal = true;
                    attrs.quantity = scope.q;
                    Cart.add(attrs).then(function (response) {
                            if(typeof response !== 'undefined'){
                                scope.loading = false;
                                scope.q = scope.minQuantity;
                                $timeout(function(){
                                    scope.showTotal = false;
                                }, 5000);
                                Cart.getContent();
                                scope.qTotall = response.qty;
                            }

                        },
                        function (response) {}
                    );
                };
                if(angular.isDefined(cartProducts)){
                    angular.forEach(cartProducts, function(value, key){
                        if(value.id == scope.id){
                            scope.q = value.qty;
                            scope.qTotall = value.qty;
                        }
                    });
                }
            },
            templateUrl: 'views/app/cart/cart-add.template.html',

        };
    }]).
    directive('removeCart', ['Cart', function(Cart){
        return {
            restrict: 'EA',
            transclude: true,
            scope: {
                rowId:'=rowId'
            },
            link: function(scope, element, attrs) {
                scope.remove = function () {
                    Cart.remove(attrs.rowid).then(function (response) {
                            Cart.getContent();
                        },
                        function (response) {}
                    );
                }
            },
            templateUrl: 'views/app/cart/cart-remove.template.html',

        };
    }]).
    directive('cartHeader', ['Cart', function(Cart){
        return {
            restrict: 'E',
            transclude: true,
            controller: ['$scope', 'Cart', function($scope, Cart) {
                this.cart = Cart;
            }],
            link: function(scope, element, attrs, controllers) {},
            templateUrl: 'views/app/cart/cart-header.template.html',
            controllerAs:'CartHeader'
        };
    }]);

'use strict';

angular.
module('core.cart').
component('cartCheckout', {
    templateUrl: 'views/app/cart/cart-checkout.template.html',
    controller: ['Cart', '$window', '$timeout', '$scope',
        function CartCheckoutController(Cart, $window, $timeout, $scope) {

            var ctrl = this;
            this.$onInit = function() {
                ctrl.cart = Cart;
                ctrl.person = {name: '', phone: '', address: ''};
                ctrl.isDisabledName = true;
                ctrl.isDisabledPhone = true;
                ctrl.isDisabledAddress = true;
                ctrl.class = '';
                ctrl.showHideName = 'Скрыть заказ';
                ctrl.showOrder = true;
                ctrl.success = false;
                ctrl.disabled = false;
                ctrl.minDisabled = false;
            };

            ctrl.updateCart = function(product, qty, value) {
                product.qty = qty;
                if(value){
                    product.qty = qty;
                }
                ctrl.disabled = true;

                Cart.update(product).then(function () {
                        $timeout(function() {
                            ctrl.disabled = false;
                        }, 300);
                        Cart.getContent();
                        ctrl.disable(product, qty);
                    },
                    function (response) {}
                );
            };

            ctrl.disable = function (product, qty) {
                if(typeof qty !== 'undefined'){
                    return parseInt(qty) <= parseInt(product.options.min);
                }
            };

            $scope.$watch(angular.bind(this, () => {
                return this.person.phone;
            }), (newVal) => {
                const newPhone = newVal.replace( /[^0-9]+/g, '');
                this.person.phone = newPhone;
                return ctrl.isDisabledPhone = typeof newPhone === 'undefined' ||
                    newPhone.length < 10 ||
                    newPhone.length > 10;
            });

            $scope.$watch(angular.bind(this, () => {
                return this.person.name;
            }), function (newVal) {
                return ctrl.isDisabledName = typeof newVal === 'undefined' || newVal.length < 4;
            });

            $scope.$watch(angular.bind(this, () => {
                return this.person.address;
            }), function (newVal) {
                return ctrl.isDisabledAddress = typeof newVal === 'undefined' || newVal.length < 10;
            });


            ctrl.sendOrder = function (valid) {
                var data = {};
                data.cart = Cart.products;
                data.person = ctrl.person;
                
                Cart.sendOrder(data).then(function (response) {
                        console.log(response.response);
                        if (response.response == 'Success') {
                            Cart.getContent();
                            ctrl.success = true;
                        }
                    },
                    function (response) {}
                );
            };


            ctrl.hideForm = function() {
                ctrl.showOrder = !ctrl.showOrder;
                if(ctrl.showOrder){
                    ctrl.showHideName = 'Скрыть заказ';
                }else{
                    ctrl.showHideName = 'Показать Заказ';
                }

            };

            var ww = $window.innerWidth;
            if(ww >= 769){
                ctrl.class = 'form-inline';
            }
        }
    ]
});

'use strict';

angular.module('homePage', [
    'ngRoute',
    'core.category'
]);
'use strict';

angular.
module('homePage').
component('homePage', {
    templateUrl: 'views/app/home-page/home-page.template.html',
    bindings: {
        slides: '<'
    },
    controller: ['$http',
        function HomePageController($http) {
            var self = this;
            this.$onInit = function() {
                self.name = 'Angular Shop';
                self.backImage = '/images/slides/image.png';

                self.carouselIndex = 0;
                self.logo = 'food-service-logo-white';
                self.backImage = function (item) {
                    var image = {'background-image': 'url(images/slides/'+item.image+')'};
                    return image;
                }
            }
            
        }
    ]
});

'use strict';

angular.module('categoryDetail', [
    'ngRoute',
    'core.category'
]);
'use strict';

angular.
module('categoryDetail').
component('categoryDetail', {
    templateUrl: 'views/app/category-detail/category-detail.template.html',
    bindings: {
        category: '=?'
    },
    controller: ['$routeParams', 'ngMeta', 'Category',
        function CategoryDetailController($routeParams, ngMeta, Category) {
            var list = this;

            list.$onInit = function() {
                this.type = 'category-detail';
                var myEl = angular.element( document.querySelector( 'body' ) );
                myEl.removeClass('no-scroll');

                ngMeta.setTitle(this.category.title);
                ngMeta.setTag('image', this.category.image);
                ngMeta.setTag('description', this.category.body.substring(0, 255));


                this.openList = function()  {
                    var ww = $window.innerWidth;
                    if(ww >= 1024){
                        return false;
                    }
                    myEl.addClass('no-scroll');
                    list.opened = !list.opened;
                    if(!list.opened){
                        myEl.removeClass('no-scroll');
                    }
                }
            };
        }
    ]
});
'use strict';
angular.module('categoryList', ['core.category']);

angular.
module('categoryList').
component('categoryList', {
    templateUrl: 'views/app/category-list/category-list.template.html',
    bindings: {
        categories: '<?'
    },
    controller: ['Category','$window',
        function CategoryListController(Category, $window) {
            'use strict';
            var list = this;
            this.$onInit = function() {
                list.categories = this.categories;
            };
            list.opened = false;


            var myEl = angular.element( document.querySelector( 'body' ) );


            if(angular.isUndefined(list.categories)){
                var query = Category.query();
                query.$promise.then(function(response) {
                    list.categories = response;
                    list.total = response.length;
                });
            }else{
                list.total = list.categories.length;
            }

            this.openList = function()  {
                var ww = $window.innerWidth;
                if(ww >= 1024){
                    return false;
                }
                myEl.addClass('no-scroll');
                list.opened = !list.opened;
                if(!list.opened){
                    myEl.removeClass('no-scroll');
                }

            }
        }
    ]
});
'use strict';
angular.module('categoryPage', ['core.category']);
angular.
module('categoryPage').
component('categoryPage', {
    templateUrl: 'views/app/category-page/category-page.template.html',
    bindings: {
        categories: '=?'
    },
    controller: ['Category',
        function CategoryPageController(Category) {
            'use strict';
            var ctrl = this;

            this.$onInit = function() {
                ctrl.categories = this.categories;
                this.total = this.categories.length || 0;
            };


            this.setPagination = function(data) {
                this.categories   = data.data;
                this.totalPages   = data.last_page;
                this.currentPage  = data.current_page;
                var pages = [];

                for(var i=1; i <= data.last_page; i++) {
                    pages.push(i);
                }
                this.range = pages;
            };

        }
    ]
});
angular.module('productDetail', [
    'ngRoute',
    'core.product'
]);
'use strict';

(function () {
    'use strict';

    angular.module('productDetail')
        .component('productDetail', {
            templateUrl: 'views/app/product-detail/product-detail.template.html',
            bindings: {
                item: '='
            },
            controller: ProductDetailController
        });
    ProductDetailController.$inject = ['$routeParams', 'Product', '$window', 'ngMeta'];

    function ProductDetailController($routeParams, Product, $window, ngMeta) {
        var ww = $window.innerWidth;
        var ctrl = this;

        this.$onInit = function () {
            ctrl.item = this.item;
            this.product = this.item.product;
            // /Seo
            ngMeta.setTitle(this.product.title);
            ngMeta.setTag('image', this.product.image);
            ngMeta.setTag('description', this.product.body.substring(0, 255));
            ctrl.showArrows = false;
            ctrl.index = 0;
            //var imageWith = ww < 414 ? 350 : null;
            var imageWith = null;

            ctrl.relatedProducts = this.item.related_products;
            ctrl.showTabs = ww >= 767;
            ctrl.type = 'product';
            ctrl.images = [];

            ctrl.prevPage = this.item.previous[0];
            ctrl.nextPage = this.item.next[0];

            if (ctrl.product.images.length) {
                ctrl.mainImage = setFirstImage();
            }

            ctrl.selectMain = function () {
                ctrl.mainImage = ctrl.images[ctrl.index].image;
            };
            ctrl.setImage = function setImage(img) {
                ctrl.index = FindIndex(img);
                ctrl.mainImage = img.image;
            };
            ctrl.setClass = function (imgUrl) {
                return imgUrl == ctrl.mainImage;
            };
            ctrl.next = function () {
                ctrl.index < ctrl.images.length - 1 ? ctrl.index++ : ctrl.index = 0;
                ctrl.selectMain();
            };

            ctrl.prev = function () {
                ctrl.index > 0 ? ctrl.index-- : ctrl.index = ctrl.images.length - 1;
                ctrl.selectMain();
            };

            if (imageWith == null) {
                angular.forEach(ctrl.product.images, function (value, key) {
                    if (value.width > 350) {
                        this.push(value);
                    }
                }, ctrl.images);
            }

                if (ctrl.images.length > 1) ctrl.showArrows = true;
                 function setFirstImage() {
                    var image;
                    if (imageWith != null) {
                        image = ctrl.product.images[0].image;
                    } else {
                        image = ctrl.product.images[1].image;
                    }
                    return image;
            }

            /**
             *
             * @param key
             * @returns {number}
             * @constructor
             */
            function FindIndex(key) {
                return ctrl.images.findIndex(function (obj) {
                    Object.keys(key).every(function (name) {
                        key[name] === obj[name]
                    })
                });
            }

        };

    }
})();
'use strict';
angular.module('productList', ['core.product']);
'use strict';
angular.
module('productList').
factory('productPagination', ['$rootScope', '$http', '$q', 'Category',
    function($rootScope, $http, $q, Category) {
         var Service = {};

        Service.changePage = function (slug, page) {
            return $http.get( '/api/categories/'+slug+'?page='+page)
                .then(function successCallback(response) {
                    var res = response.data;
                    if (angular.isDefined(res)) {
                        return res;
                    } else {
                        // invalid response
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });



        };

        return Service;
    }
]);
'use strict';

angular.
module('productList').
component('productList', {
    bindings: {
        products: '<?',
        onPrevPage: '&',
        onNextPage: '&',
        categorySlug: '='
    },
    templateUrl: 'views/app/product-list/product-list.template.html',
    controller: ['Product', '$routeParams', 'productPagination',
        function ProductListController(Product, $routeParams, productPagination) {
        
            this.$onInit = function() {
                  var query;
                  var list = this;
                  this.type = 'products-list';

                  this.menuIsShow = false;
                  if(angular.isDefined(this.products)) {
                      if (typeof this.products.current_page !== 'undefined') {
                          list.pagination = Object.assign({}, this.products);
                          list.products = this.products.data;
                      }
                  }

                  //If not on category-detail page
                  if(angular.isUndefined(this.products)){
                      query = Product.query();
                      list.type = 'home-page';

                      query.$promise.then(function(response) {
                          if(angular.isDefined(response)){
                              list.listToPaginate = response;
                              list.products = response.data;
                              list.type = 'home-page';
                          }
                      });
                  }

                  this.changePage = function (page) {
                      productPagination.changePage(this.categorySlug, page).then(function (response) {
                              list.pagination = response.products;
                              list.products = response.products.data;
                          },
                          function (response) {}
                      );
                  };


                  this.openListCategories = function() {
                      list.menuIsShow = true;
                  }
            };
        }
    ]
});
angular.module('core.nav', [
    'ngRoute'
]);
'use strict';

angular.
module('core.nav').
component('navList', {
    templateUrl: 'views/app/nav/nav.html',
    controller: ['$routeParams', 'Cart', '$route',
        function NavigationList($routeParams, Cart, $route) {
            this.items = [
                {name: 'Каталог', className: 'first-li', url: '/categories'},
                {name: 'Контакты', className: 'other-li', url: '/contacts'},
                {name: 'Корзина', className: 'second-li', url: '/cart/checkout', count: true},
                /*{name: 'Доставка и Оплата', className: 'other-li last-el',  url: '/payment/'}*/
            ]
        }
    ]
});
angular.module('core.slides', [
    'ngRoute'
]);
'use strict';

angular.module( 'core.slides', [])
    .factory('slidesService', ['$http', '$q',
        function($http, $q ) {
            var self = this;


            self.getSlides = function () {
                 return $http({
                    method: 'GET',
                    url: '/api/slides/'
                }).then(function successCallback(response) {
                    if(angular.isDefined(response)) {
                        return response.data;
                    } else {
                        return $q.reject(response.data);
                    }
                }, function errorCallback(response) {
                    return $q.reject(response);
                });
            };


            return self;
        }
    ]);

angular.module('core.pagination', [
    'ngRoute'
]);
'use strict';

angular.module( 'core.pagination', [])
    .factory('paginationService', ['$http', '$q',
        function($http, $q ) {
            this.getTwoElementsByType = function(data){
                return $http.post('/pagination/', data)
                    .then(function successCallback(response) {


                    }, function errorCallback(response) {
                        return $q.reject(response);
                    });
            };


            return this;
        }
    ]);
'use strict';

angular.
module('core.pagination').
component('paginationList', {
    bindings: {
        item: '<',
        type:'=',
        nextPage:'&'
    },
    templateUrl: 'views/app/pagination/pagination.html',
    controller: ['$routeParams', '$route', 'paginationService',
        function PaginationList($routeParams, $route, paginationService) {
            var self = this;
            this.$onInit = function() {
                
            }

            if(self.type == 'product'){
                this.obj = this.item.product;
                this.prevPage = this.item.previous;
                this.nextPage = this.item.next;

            }
        }
    ]
});
//# sourceMappingURL=app.js.map
